import Overview from "./overview";
import EventsCenter from "./events-center";
import Settings from "./settings";
import UserAccount from "./user-account";
import UserProfile from "./user-profile";
import Workspace from "./workspace";
import WorkspaceCreate from "./workspace-create";
import DeveloperGuide from "./developer-guide";
import Customers from "./customers";
import CustomerProfile from "./customers/profile";

// Page registration is explicit so a new business module is always opt-in.
export const pagesMap = {
    Overview,
    EventsCenter,
    Settings,
    UserAccount,
    UserProfile,
    Workspace,
    WorkspaceCreate,
    DeveloperGuide,
    Customers,
    CustomerProfile,
};
